import { FILTER_DATE_CUSTOM_KEY, TimePeriodOptions } from '../../constants'
import { DsrRequestStatus, DsrRequestStatusFilterKey } from '../../services/graphqlSchemaTypes'
import dayjs from 'dayjs'

export function isDsrRequestVerified(status?: DsrRequestStatus) {
  return (
    status === DsrRequestStatus.IdVerified ||
    status === DsrRequestStatus.ReportGeneration ||
    status === DsrRequestStatus.DataDiscovery
  )
}

export function isDsrRequestDisableRequestStatus(status?: DsrRequestStatus) {
  return (
    status === DsrRequestStatus.IdUnverified ||
    status === DsrRequestStatus.Closed ||
    status === DsrRequestStatus.Rejected
  )
}

export const disableRequestStatusTextMapper = {
  [DsrRequestStatus.IdUnverified]: 'dsr.dataDiscovery.action.disable.idunverified',
  [DsrRequestStatus.Closed]: 'dsr.dataDiscovery.action.disable.closed',
  [DsrRequestStatus.Rejected]: 'dsr.dataDiscovery.action.disable.rejected'
}

export const getCreatedDateUrlFilter = (timePeriod: string) => {
  if (timePeriod === '' || timePeriod === TimePeriodOptions.FROM_THE_START) return ''

  const mapTimePeriodToStartDate = {
    [TimePeriodOptions.ONE_MONTH]: dayjs().subtract(1, 'M').format('YYYY-MM-DD'),
    [TimePeriodOptions.THREE_MONTHS]: dayjs().subtract(3, 'M').format('YYYY-MM-DD'),
    [TimePeriodOptions.SIX_MONTHS]: dayjs().subtract(6, 'M').format('YYYY-MM-DD'),
    [TimePeriodOptions.ONE_YEAR]: dayjs().subtract(1, 'y').format('YYYY-MM-DD')
  }

  return `${FILTER_DATE_CUSTOM_KEY},${mapTimePeriodToStartDate[timePeriod]},${dayjs().format(
    'YYYY-MM-DD'
  )}`
}

export const statusValueToLabelFilterKey = {
  [DsrRequestStatusFilterKey.IdUnverified]: 'dsr.requestManagement.step.idUnverified',
  [DsrRequestStatusFilterKey.IdVerified]: 'dsr.requestManagement.step.idVerified',
  [DsrRequestStatusFilterKey.DataDiscovery]: 'dsr.requestManagement.step.dataDiscovery',
  [DsrRequestStatusFilterKey.ReportGeneration]: 'dsr.requestManagement.step.report',
  [DsrRequestStatusFilterKey.Closed]: 'dsr.requestManagement.step.closure',
  [DsrRequestStatusFilterKey.Rejected]: 'dsr.requestManagement.step.rejected',
  [DsrRequestStatusFilterKey.AwaitingEmailVerification]:
    'dsr.requestManagement.step.awaitingEmailVerification',
  [DsrRequestStatusFilterKey.AwaitingApproval]: 'dsr.requestManagement.step.awaitingApproval'
}
